import { render } from "./LinkBlock.vue?vue&type=template&id=08ec59f4&scoped=true"
import script from "./LinkBlock.vue?vue&type=script&lang=js"
export * from "./LinkBlock.vue?vue&type=script&lang=js"

import "./LinkBlock.vue?vue&type=style&index=0&id=08ec59f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ec59f4"]])

export default __exports__